import { render } from "./WatchView.vue?vue&type=template&id=232a0a24"
import script from "./WatchView.vue?vue&type=script&lang=js"
export * from "./WatchView.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__